import type { HasilZaka, JariMasukan } from "@dfa/types";
import { hitungZaka } from "../../../worker/src/rumus/zaka/index.js";
import kiranaFixture from "../../../../docs/tugas/aset/008-vektor-rumus-zaka.json";

export { hitungZaka };

export type KasusVektor = {
  nama: string;
  masukan: JariMasukan[];
};

export const VEKTOR_RUMUS: KasusVektor[] = kiranaFixture as KasusVektor[];

export function hitungDariKode(kode: string): HasilZaka | null {
  const kasus = VEKTOR_RUMUS.find((k) => k.nama === kode || kode === "kirana-mockup");
  if (!kasus) return null;
  return hitungZaka(kasus.masukan);
}

export function hitungDenganArch(): HasilZaka {
  const kasus = VEKTOR_RUMUS.find((k) => k.nama === "dengan-arch")!;
  return hitungZaka(kasus.masukan);
}
